// ==========================================
// EMPLEADO - FRONTEND
// ==========================================


// ==========================================
// VARIABLES GLOBALES
// ==========================================

let empleadosGlobales = [];

let empleadoEditando = null;


// ==========================================
// OBTENER CAMPO DEL MODAL ACTUALIZAR
// ==========================================

function obtenerCampoModalActualizar(id) {

    const modal =
        document.getElementById(
            'modalActualizar'
        );

    if (modal) {

        const campo =
            modal.querySelector(
                `#${id}`
            );

        if (campo) {

            return campo;

        }

    }

    return document.getElementById(id);

}


// ==========================================
// FORMATEAR FECHA PARA MOSTRAR
// ==========================================

function formatearFecha(fecha) {

    if (
        fecha === null ||
        fecha === undefined ||
        fecha === ''
    ) {

        return '';

    }

    const fechaInput =
        fechaParaInput(fecha);

    if (!fechaInput) {

        return '';

    }

    const partes =
        fechaInput.split('-');

    if (partes.length === 3) {

        return `${partes[2]}/${partes[1]}/${partes[0]}`;

    }

    return '';

}


// ==========================================
// CONVERTIR FECHA PARA INPUT DATE
// ==========================================

function fechaParaInput(fecha) {

    if (
        fecha === null ||
        fecha === undefined ||
        fecha === ''
    ) {

        return '';

    }


    // ==========================================
    // SI YA ES OBJETO DATE
    // ==========================================

    if (fecha instanceof Date) {

        if (
            isNaN(
                fecha.getTime()
            )
        ) {

            return '';

        }

        const año =
            fecha.getFullYear();

        const mes =
            String(
                fecha.getMonth() + 1
            ).padStart(
                2,
                '0'
            );

        const dia =
            String(
                fecha.getDate()
            ).padStart(
                2,
                '0'
            );

        return `${año}-${mes}-${dia}`;

    }


    // ==========================================
    // CONVERTIR A TEXTO
    // ==========================================

    const texto =
        String(fecha).trim();

    if (!texto) {

        return '';

    }


    // ==========================================
    // FORMATO SQL / ISO
    //
    // 2026-10-02
    // 2026-10-02T00:00:00.000Z
    // 2026-10-02 00:00:00.000
    // ==========================================

    let coincidencia =
        texto.match(
            /^(\d{4})-(\d{2})-(\d{2})(?:[T\s].*)?$/
        );

    if (coincidencia) {

        return (
            `${coincidencia[1]}-` +
            `${coincidencia[2]}-` +
            `${coincidencia[3]}`
        );

    }


    // ==========================================
    // FORMATO DD/MM/YYYY
    // ==========================================

    coincidencia =
        texto.match(
            /^(\d{2})\/(\d{2})\/(\d{4})$/
        );

    if (coincidencia) {

        const parte1 =
            Number(
                coincidencia[1]
            );

        const parte2 =
            Number(
                coincidencia[2]
            );

        const año =
            coincidencia[3];


        // ==========================================
        // SI EL PRIMER VALOR > 12
        // ES NECESARIAMENTE EL DÍA
        // ==========================================

        if (parte1 > 12) {

            return (
                `${año}-` +
                `${String(parte2).padStart(2, '0')}-` +
                `${String(parte1).padStart(2, '0')}`
            );

        }


        // ==========================================
        // SI EL SEGUNDO VALOR > 12
        // ES NECESARIAMENTE EL DÍA
        // ==========================================

        if (parte2 > 12) {

            return (
                `${año}-` +
                `${String(parte1).padStart(2, '0')}-` +
                `${String(parte2).padStart(2, '0')}`
            );

        }


        // ==========================================
        // PARA ESTE SISTEMA
        // SE INTERPRETA COMO DD/MM/YYYY
        // ==========================================

        return (
            `${año}-` +
            `${String(parte2).padStart(2, '0')}-` +
            `${String(parte1).padStart(2, '0')}`
        );

    }


    // ==========================================
    // FORMATO DD-MM-YYYY
    // ==========================================

    coincidencia =
        texto.match(
            /^(\d{2})-(\d{2})-(\d{4})$/
        );

    if (coincidencia) {

        const dia =
            Number(
                coincidencia[1]
            );

        const mes =
            Number(
                coincidencia[2]
            );

        const año =
            coincidencia[3];

        return (
            `${año}-` +
            `${String(mes).padStart(2, '0')}-` +
            `${String(dia).padStart(2, '0')}`
        );

    }


    // ==========================================
    // FORMATO MM/DD/YYYY
    // ==========================================

    coincidencia =
        texto.match(
            /^(\d{2})\/(\d{2})\/(\d{4})$/
        );

    if (coincidencia) {

        const primero =
            Number(
                coincidencia[1]
            );

        const segundo =
            Number(
                coincidencia[2]
            );

        const año =
            coincidencia[3];


        if (primero > 12) {

            return (
                `${año}-` +
                `${String(segundo).padStart(2, '0')}-` +
                `${String(primero).padStart(2, '0')}`
            );

        }


        if (segundo > 12) {

            return (
                `${año}-` +
                `${String(primero).padStart(2, '0')}-` +
                `${String(segundo).padStart(2, '0')}`
            );

        }

    }


    // ==========================================
    // ÚLTIMO INTENTO CON Date()
    // ==========================================

    const fechaObj =
        new Date(texto);

    if (
        isNaN(
            fechaObj.getTime()
        )
    ) {

        console.warn(
            '⚠️ Fecha no reconocida:',
            fecha
        );

        return '';

    }


    const año =
        fechaObj.getFullYear();

    const mes =
        String(
            fechaObj.getMonth() + 1
        ).padStart(
            2,
            '0'
        );

    const dia =
        String(
            fechaObj.getDate()
        ).padStart(
            2,
            '0'
        );

    return `${año}-${mes}-${dia}`;

}


// ==========================================
// ASIGNAR FECHA A INPUT DATE
// ==========================================

function asignarFechaInput(
    campo,
    fecha
) {

    if (!campo) {

        return;

    }

    campo.type =
        'date';

    const fechaConvertida =
        fechaParaInput(fecha);

    console.log(
        '📅 FECHA ORIGINAL:',
        fecha
    );

    console.log(
        '📅 FECHA CONVERTIDA:',
        fechaConvertida
    );

    campo.value =
        fechaConvertida;

}


// ==========================================
// OBTENER FECHA ACTUAL
// ==========================================

function obtenerFechaActual() {

    const hoy =
        new Date();

    const año =
        hoy.getFullYear();

    const mes =
        String(
            hoy.getMonth() + 1
        ).padStart(
            2,
            '0'
        );

    const dia =
        String(
            hoy.getDate()
        ).padStart(
            2,
            '0'
        );

    return `${año}-${mes}-${dia}`;

}


// ==========================================
// ESCAPAR HTML
// ==========================================

function escaparHTML(valor) {

    if (
        valor === undefined ||
        valor === null
    ) {

        return '';

    }

    return String(valor)
        .replace(
            /&/g,
            '&amp;'
        )
        .replace(
            /</g,
            '&lt;'
        )
        .replace(
            />/g,
            '&gt;'
        )
        .replace(
            /"/g,
            '&quot;'
        )
        .replace(
            /'/g,
            '&#039;'
        );

}


// ==========================================
// MOSTRAR ESTADO
// ==========================================

function mostrarEstado(estado) {

    if (!estado) {

        return '';

    }

    const estadoTexto =
        String(
            estado
        ).toUpperCase();

    if (
        estadoTexto === 'A' ||
        estadoTexto === 'ACTIVO'
    ) {

        return `
            <span class="badge bg-success">
                ACTIVO
            </span>
        `;

    }

    return `
        <span class="badge bg-secondary">
            ${escaparHTML(
                estadoTexto
            )}
        </span>
    `;

}


// ==========================================
// CARGAR EMPLEADOS
// ==========================================

async function cargarEmpleados() {

    const tbody =
        document.getElementById(
            'tbodyEmpleados'
        );

    if (!tbody) {

        console.error(
            '❌ No existe #tbodyEmpleados'
        );

        return;

    }

    tbody.innerHTML = `

        <tr>

            <td
                colspan="13"
                class="text-center py-4"
            >

                <div
                    class="spinner-border"
                    role="status"
                ></div>

                <div class="mt-2">
                    Cargando empleados...
                </div>

            </td>

        </tr>

    `;


    try {

        console.log('');

        console.log(
            '================================='
        );

        console.log(
            'CONSULTANDO EMPLEADOS'
        );

        console.log(
            '================================='
        );


        const respuesta =
            await fetch(
                '/empleado/listar',
                {

                    method:
                        'GET',

                    headers: {

                        'Accept':
                            'application/json'

                    }

                }
            );


        console.log(
            'STATUS:',
            respuesta.status
        );


        const texto =
            await respuesta.text();


        console.log(
            'RESPUESTA:',
            texto
        );


        let resultado;


        try {

            resultado =
                JSON.parse(
                    texto
                );

        } catch (error) {

            console.error(
                '❌ El servidor no devolvió JSON'
            );

            throw new Error(
                'El servidor devolvió una respuesta inválida.'
            );

        }


        if (!respuesta.ok) {

            throw new Error(
                resultado.mensaje ||
                'Error al cargar empleados.'
            );

        }


        if (
            resultado.success === false
        ) {

            throw new Error(
                resultado.mensaje ||
                'No se pudieron cargar los empleados.'
            );

        }


        // ==========================================
        // OBTENER EMPLEADOS
        // ==========================================

        if (Array.isArray(resultado)) {

            empleadosGlobales =
                resultado;

        } else {

            empleadosGlobales =
                resultado.empleados ||
                resultado.data ||
                [];

        }


        if (
            !Array.isArray(
                empleadosGlobales
            )
        ) {

            console.error(
                '❌ La respuesta no es un arreglo:',
                empleadosGlobales
            );

            empleadosGlobales =
                [];

        }


        tbody.innerHTML =
            '';


        // ==========================================
        // SIN EMPLEADOS
        // ==========================================

        if (
            empleadosGlobales.length === 0
        ) {

            tbody.innerHTML = `

                <tr>

                    <td
                        colspan="13"
                        class="text-center text-muted py-4"
                    >

                        <i class="bi bi-info-circle"></i>

                        No existen empleados activos.

                    </td>

                </tr>

            `;

            return;

        }


        // ==========================================
        // RECORRER EMPLEADOS
        // ==========================================

        empleadosGlobales.forEach(
            empleado => {

                const fila =
                    document.createElement(
                        'tr'
                    );


                // ==========================================
                // 13 COLUMNAS
                // ==========================================
                //
                // 1  ID
                // 2  Empleado
                // 3  Puesto
                // 4  DPI
                // 5  Fecha nacimiento
                // 6  Edad
                // 7  Dirección
                // 8  Teléfono
                // 9  Departamento
                // 10 Municipio
                // 11 Estado
                // 12 Registro
                // 13 Acciones
                //
                // ==========================================

                fila.innerHTML = `

                    <td>
                        ${escaparHTML(
                            empleado.IDEMPLEADO
                        )}
                    </td>

                    <td>

                        <strong>

                            ${escaparHTML(
                                empleado.NOMBREEMPLEADO
                            )}

                        </strong>

                    </td>

                    <td>

                        ${escaparHTML(
                            empleado.NOMBREPUESTO
                        )}

                    </td>

                    <td>

                        ${escaparHTML(
                            empleado.DPI
                        )}

                    </td>

                    <td>

                        ${formatearFecha(
                            empleado.FECHANACIMIENTO
                        )}

                    </td>

                    <td>

                        ${escaparHTML(
                            empleado.EDAD
                        )}

                    </td>

                    <td>

                        ${escaparHTML(
                            empleado.DIRECCION
                        )}

                    </td>

                    <td>

                        <i
                            class="bi bi-telephone"
                        ></i>

                        ${escaparHTML(
                            empleado.TELEFONO
                        )}

                    </td>

                    <td>

                        ${escaparHTML(
                            empleado.NOMBREDEPARTAMENTO
                        )}

                    </td>

                    <td>

                        ${escaparHTML(
                            empleado.NOMBREMUNICIPIO
                        )}

                    </td>

                    <td>

                        ${mostrarEstado(
                            empleado.ESTADO
                        )}

                    </td>

                    <td>

                        ${formatearFecha(
                            empleado.FECHAREGISTROEMPLE
                        )}

                    </td>

                    <td
                        class="text-center"
                    >

                        <button
                            type="button"
                            class="btn btn-sm btn-warning btnEditarEmpleado"
                            title="Editar"
                            data-id="${escaparHTML(
                                empleado.IDEMPLEADO
                            )}"
                        >

                            <i
                                class="bi bi-pencil-fill"
                            ></i>

                        </button>


                        <button
                            type="button"
                            class="btn btn-sm btn-danger btnEliminarEmpleado"
                            title="Desactivar"
                            data-id="${escaparHTML(
                                empleado.IDEMPLEADO
                            )}"
                        >

                            <i
                                class="bi bi-trash-fill"
                            ></i>

                        </button>

                    </td>

                `;


                tbody.appendChild(
                    fila
                );

            }
        );


        console.log(
            '✅ Empleados cargados:',
            empleadosGlobales.length
        );


    } catch (error) {

        console.error(
            '❌ ERROR AL CARGAR EMPLEADOS:',
            error
        );


        tbody.innerHTML = `

            <tr>

                <td
                    colspan="13"
                    class="text-center text-danger py-4"
                >

                    <strong>
                        Error al cargar empleados
                    </strong>

                    <br>

                    ${escaparHTML(
                        error.message
                    )}

                </td>

            </tr>

        `;

    }

}


// ==========================================
// BUSCAR EMPLEADOS
// ==========================================

function buscarEmpleados() {

    const input =
        document.getElementById(
            'buscarEmpleado'
        );

    const tbody =
        document.getElementById(
            'tbodyEmpleados'
        );


    if (
        !input ||
        !tbody
    ) {

        return;

    }


    input.addEventListener(
        'input',
        function () {

            const texto =
                this.value
                    .toLowerCase()
                    .trim();


            const filas =
                tbody.querySelectorAll(
                    'tr'
                );


            filas.forEach(
                fila => {

                    const contenido =
                        fila.textContent
                            .toLowerCase();


                    if (
                        contenido.includes(
                            texto
                        )
                    ) {

                        fila.style.display =
                            '';

                    } else {

                        fila.style.display =
                            'none';

                    }

                }
            );

        }
    );

}


// ==========================================
// COLOCAR FECHAS
// ==========================================

function colocarFechas() {

    const fechaActual =
        obtenerFechaActual();


    // ==========================================
    // FECHA REGISTRO EMPLEADO
    // ==========================================

    const fechaRegistro =
        document.getElementById(
            'fechaRegistro'
        );


    if (fechaRegistro) {

        fechaRegistro.type =
            'date';

        fechaRegistro.value =
            fechaActual;

    }


    // ==========================================
    // FECHA REGISTRO PUESTO
    // ==========================================

    const fechaRegistroPuesto =
        document.getElementById(
            'fechaRegistroPuesto'
        );


    if (
        fechaRegistroPuesto &&
        !empleadoEditando
    ) {

        fechaRegistroPuesto.type =
            'date';

        fechaRegistroPuesto.value =
            fechaActual;

    }


    // ==========================================
    // FECHA INGRESO DEPARTAMENTO
    // ==========================================

    const fechaIngresoDepart =
        document.getElementById(
            'fechaIngresoDepart'
        );


    if (fechaIngresoDepart) {

        fechaIngresoDepart.type =
            'date';

        fechaIngresoDepart.value =
            fechaActual;

    }

}


// ==========================================
// LIMPIAR FORMULARIO
// ==========================================

function limpiarFormulario() {

    const formulario =
        document.getElementById(
            'formEmpleado'
        );


    if (!formulario) {

        return;

    }


    formulario.reset();


    empleadoEditando =
        null;


    colocarFechas();


    // ==========================================
    // ESTADO EMPLEADO
    // ==========================================

    const estado =
        document.getElementById(
            'estado'
        );


    if (estado) {

        estado.value =
            'A';

    }


    // ==========================================
    // ESTADO TELÉFONO
    // ==========================================

    const estadoTelefono =
        document.getElementById(
            'estadoTelefono'
        );


    if (estadoTelefono) {

        estadoTelefono.value =
            'A';

    }


    // ==========================================
    // ESTADO PUESTO
    // ==========================================

    const estadoPuesto =
        document.getElementById(
            'estadoPuesto'
        );


    if (estadoPuesto) {

        estadoPuesto.value =
            'A';

    }


    // ==========================================
    // ESTADO DEPARTAMENTO
    // ==========================================

    const estadoDepartamento =
        document.getElementById(
            'estadoDepartamento'
        );


    if (estadoDepartamento) {

        estadoDepartamento.value =
            'A';

    }

}


// ==========================================
// CAMBIAR TÍTULO MODAL
// ==========================================

function cambiarTituloModal(titulo) {

    const tituloModal =
        document.getElementById(
            'tituloModalEmpleado'
        );


    if (tituloModal) {

        tituloModal.textContent =
            titulo;

        return;

    }


    const tituloAlternativo =
        document.querySelector(
            '#modalEmpleado .modal-title'
        );


    if (tituloAlternativo) {

        tituloAlternativo.textContent =
            titulo;

    }

}


// ==========================================
// ABRIR MODAL EMPLEADO
// ==========================================

function abrirModalEmpleado() {

    const modalElement =
        document.getElementById(
            'modalEmpleado'
        );


    if (!modalElement) {

        console.error(
            '❌ No existe #modalEmpleado'
        );

        return;

    }


    if (
        typeof bootstrap ===
        'undefined'
    ) {

        console.error(
            '❌ Bootstrap no está disponible'
        );

        return;

    }


    const modal =
        bootstrap.Modal
            .getOrCreateInstance(
                modalElement
            );


    modal.show();

}


// ==========================================
// ABRIR MODAL NUEVO EMPLEADO
// ==========================================

function abrirModalNuevoEmpleado() {

    console.log(
        '➕ NUEVO EMPLEADO'
    );


    empleadoEditando =
        null;


    limpiarFormulario();


    cambiarTituloModal(
        'Registrar empleado'
    );


    abrirModalEmpleado();

}


// ==========================================
// ABRIR MODAL ACTUALIZAR
// ==========================================

function abrirModalActualizar(idEmpleado) {

    console.log(
        '================================='
    );

    console.log(
        '✏️ EDITANDO EMPLEADO'
    );

    console.log(
        'ID:',
        idEmpleado
    );

    console.log(
        '================================='
    );


    const empleado =
        empleadosGlobales.find(
            item =>
                Number(
                    item.IDEMPLEADO
                ) ===
                Number(
                    idEmpleado
                )
        );


    if (!empleado) {

        console.error(
            '❌ No se encontró el empleado:',
            idEmpleado
        );

        alert(
            '❌ No se encontró la información del empleado.'
        );

        return;

    }


    empleadoEditando =
        Number(idEmpleado);


    console.log(
        'Empleado seleccionado:',
        empleado
    );


    // ==========================================
    // MOSTRAR FECHAS RECIBIDAS
    // ==========================================

    console.log(
        '📅 FECHA EMPLEADO:',
        empleado.FECHAREGISTROEMPLE
    );

    console.log(
        '📅 FECHA PUESTO:',
        empleado.FECHAREGISTRO
    );

    console.log(
        '📅 FECHA PUESTO ALTERNATIVA:',
        empleado.FECHAREGISTROPUESTO
    );

    console.log(
        '📅 FECHA DEPARTAMENTO:',
        empleado.FECHAINGRESODEPART
    );


    // ==========================================
    // CAMPOS
    // ==========================================

    const id =
        obtenerCampoModalActualizar(
            'actualizarIdEmpleado'
        );


    const nombre =
        obtenerCampoModalActualizar(
            'actualizarNombreEmpleado'
        );


    const dpi =
        obtenerCampoModalActualizar(
            'actualizarDpi'
        );


    const fechaNacimiento =
        obtenerCampoModalActualizar(
            'actualizarFechaNacimiento'
        );


    const edad =
        obtenerCampoModalActualizar(
            'actualizarEdad'
        );


    const estado =
        obtenerCampoModalActualizar(
            'actualizarEstado'
        );


    const fechaRegistro =
        obtenerCampoModalActualizar(
            'actualizarFechaRegistro'
        );


    const direccion =
        obtenerCampoModalActualizar(
            'actualizarDireccion'
        );


    const telefono =
        obtenerCampoModalActualizar(
            'actualizarTelefono'
        );


    const estadoTelefono =
        obtenerCampoModalActualizar(
            'actualizarEstadoTelefono'
        );


    const nombrePuesto =
        obtenerCampoModalActualizar(
            'actualizarNombrePuesto'
        );


    const fechaRegistroPuesto =
        obtenerCampoModalActualizar(
            'actualizarFechaRegistroPuesto'
        );


    const estadoPuesto =
        obtenerCampoModalActualizar(
            'actualizarEstadoPuesto'
        );


    const departamento =
        obtenerCampoModalActualizar(
            'actualizarNombreDepartamento'
        );


    const fechaIngresoDepart =
        obtenerCampoModalActualizar(
            'actualizarFechaIngresoDepart'
        );


    const estadoDepartamento =
        obtenerCampoModalActualizar(
            'actualizarEstadoDepartamento'
        );


    const municipio =
        obtenerCampoModalActualizar(
            'actualizarNombreMunicipio'
        );


    // ==========================================
    // CARGAR DATOS GENERALES
    // ==========================================

    if (id) {

        id.value =
            empleado.IDEMPLEADO ?? '';

    }


    if (nombre) {

        nombre.value =
            empleado.NOMBREEMPLEADO ?? '';

    }


    if (dpi) {

        dpi.value =
            empleado.DPI ?? '';

    }


    // ==========================================
    // FECHA NACIMIENTO
    // ==========================================

    if (fechaNacimiento) {

        asignarFechaInput(
            fechaNacimiento,
            empleado.FECHANACIMIENTO
        );

    }


    // ==========================================
    // EDAD
    // ==========================================

    if (edad) {

        edad.value =
            empleado.EDAD ?? '';

    }


    // ==========================================
    // ESTADO
    // ==========================================

    if (estado) {

        estado.value =
            empleado.ESTADO ?? 'A';

    }


    // ==========================================
    // FECHA REGISTRO EMPLEADO
    // ==========================================

    if (fechaRegistro) {

        asignarFechaInput(
            fechaRegistro,
            empleado.FECHAREGISTROEMPLE
        );

    }


    // ==========================================
    // DIRECCIÓN
    // ==========================================

    if (direccion) {

        direccion.value =
            empleado.DIRECCION ?? '';

    }


    // ==========================================
    // TELÉFONO
    // ==========================================

    if (telefono) {

        telefono.value =
            empleado.TELEFONO ?? '';

    }


    // ==========================================
    // ESTADO TELÉFONO
    //
    // SOLO VISUAL
    // NO SE ENVÍA A SP_EMPLEADO_U
    // ==========================================

    if (estadoTelefono) {

        estadoTelefono.value =
            empleado.ESTADOTELEFONO ?? 'A';

    }


    // ==========================================
    // PUESTO
    // ==========================================

    if (nombrePuesto) {

        nombrePuesto.value =
            empleado.NOMBREPUESTO ?? '';

    }


    // ==========================================
    // FECHA REGISTRO PUESTO
    //
    // SOLO VISUAL
    // NO SE ENVÍA A SP_EMPLEADO_U
    // ==========================================

    if (fechaRegistroPuesto) {

        const fechaPuesto =
            empleado.FECHAREGISTRO ??
            empleado.FECHAREGISTROPUESTO ??
            empleado.FECHAREGISTROPUESTOEMPLEADO;

        console.log(
            '📅 FECHA PUESTO UTILIZADA:',
            fechaPuesto
        );


        asignarFechaInput(
            fechaRegistroPuesto,
            fechaPuesto
        );

    }


    // ==========================================
    // ESTADO PUESTO
    //
    // SOLO VISUAL
    // NO SE ENVÍA A SP_EMPLEADO_U
    // ==========================================

    if (estadoPuesto) {

        estadoPuesto.value =
            empleado.ESTADOPUESTO ?? 'A';

    }


    // ==========================================
    // DEPARTAMENTO
    // ==========================================

    if (departamento) {

        departamento.value =
            empleado.NOMBREDEPARTAMENTO ?? '';

    }


    // ==========================================
    // FECHA INGRESO DEPARTAMENTO
    //
    // SOLO VISUAL
    //
    // SP_EMPLEADO_U UTILIZA GETDATE()
    // PARA ACTUALIZAR ESTA FECHA
    // ==========================================

    if (fechaIngresoDepart) {

        const fechaDepartamento =
            empleado.FECHAINGRESODEPART ??
            empleado.FECHAINGRESODEPARTAMENTO ??
            empleado.FECHAINGRESODEPARTAMENTOEMPLEADO;

        console.log(
            '📅 FECHA DEPARTAMENTO UTILIZADA:',
            fechaDepartamento
        );


        asignarFechaInput(
            fechaIngresoDepart,
            fechaDepartamento
        );

    }


    // ==========================================
    // ESTADO DEPARTAMENTO
    // ==========================================

    if (estadoDepartamento) {

        estadoDepartamento.value =
            empleado.ESTADODEPARTAMENTO ?? 'A';

    }


    // ==========================================
    // MUNICIPIO
    // ==========================================

    if (municipio) {

        municipio.value =
            empleado.NOMBREMUNICIPIO ?? '';

    }


    // ==========================================
    // VERIFICAR FECHAS
    // ==========================================

    console.log(
        '================================='
    );

    console.log(
        '📅 VALORES FINALES DEL MODAL'
    );

    console.log(
        'Empleado:',
        fechaRegistro
            ? fechaRegistro.value
            : 'NO EXISTE'
    );

    console.log(
        'Puesto:',
        fechaRegistroPuesto
            ? fechaRegistroPuesto.value
            : 'NO EXISTE'
    );

    console.log(
        'Departamento:',
        fechaIngresoDepart
            ? fechaIngresoDepart.value
            : 'NO EXISTE'
    );

    console.log(
        '================================='
    );


    // ==========================================
    // ABRIR MODAL
    // ==========================================

    const modalElemento =
        document.getElementById(
            'modalActualizar'
        );


    if (!modalElemento) {

        console.error(
            '❌ No existe #modalActualizar'
        );

        alert(
            '❌ No se encontró el modal de actualización.'
        );

        return;

    }


    if (
        typeof bootstrap ===
        'undefined'
    ) {

        console.error(
            '❌ Bootstrap no está disponible'
        );

        return;

    }


    const modal =
        bootstrap.Modal
            .getOrCreateInstance(
                modalElemento
            );


    modal.show();

}


// ==========================================
// GUARDAR EMPLEADO
// ==========================================

async function guardarEmpleado() {

    const formulario =
        document.getElementById(
            'formEmpleado'
        );


    if (!formulario) {

        console.error(
            '❌ No existe #formEmpleado'
        );

        return;

    }


    if (
        !formulario.checkValidity()
    ) {

        formulario.reportValidity();

        return;

    }


    // ==========================================
    // CAMPOS
    // ==========================================

    const nombreEmpleado =
        document.getElementById(
            'nombreEmpleado'
        );


    const dpi =
        document.getElementById(
            'dpi'
        );


    const fechaNacimiento =
        document.getElementById(
            'fechaNacimiento'
        );


    const edad =
        document.getElementById(
            'edad'
        );


    const estado =
        document.getElementById(
            'estado'
        );


    const fechaRegistro =
        document.getElementById(
            'fechaRegistro'
        );


    const direccion =
        document.getElementById(
            'direccion'
        );


    const telefono =
        document.getElementById(
            'telefono'
        );


    const estadoTelefono =
        document.getElementById(
            'estadoTelefono'
        );


    const nombrePuesto =
        document.getElementById(
            'nombrePuesto'
        );


    const fechaRegistroPuesto =
        document.getElementById(
            'fechaRegistroPuesto'
        );


    const estadoPuesto =
        document.getElementById(
            'estadoPuesto'
        );


    const nombreDepartamento =
        document.getElementById(
            'nombreDepartamento'
        );


    const fechaIngresoDepart =
        document.getElementById(
            'fechaIngresoDepart'
        );


    const estadoDepartamento =
        document.getElementById(
            'estadoDepartamento'
        );


    const nombreMunicipio =
        document.getElementById(
            'nombreMunicipio'
        );


    // ==========================================
    // VALIDAR DIRECCIÓN
    // ==========================================

    if (
        !direccion ||
        !direccion.value.trim()
    ) {

        alert(
            '❌ La dirección del empleado es obligatoria.'
        );


        if (direccion) {

            direccion.focus();

        }


        return;

    }


    // ==========================================
    // VALIDAR MUNICIPIO
    // ==========================================

    if (
        !nombreMunicipio ||
        !nombreMunicipio.value.trim()
    ) {

        alert(
            '❌ El nombre del municipio es obligatorio.'
        );


        if (nombreMunicipio) {

            nombreMunicipio.focus();

        }


        return;

    }


    // ==========================================
    // VALIDAR TELÉFONO
    // ==========================================

    if (
        !telefono ||
        !/^[0-9]{8}$/.test(
            telefono.value.trim()
        )
    ) {

        alert(
            '❌ El teléfono debe contener exactamente 8 dígitos.'
        );


        if (telefono) {

            telefono.focus();

        }


        return;

    }


    // ==========================================
    // CALCULAR EDAD
    // ==========================================

    let edadValor =
        null;


    if (
        fechaNacimiento &&
        fechaNacimiento.value
    ) {

        edadValor =
            calcularEdad(
                fechaNacimiento.value
            );


        if (edad) {

            edad.value =
                edadValor;

        }

    }


    // ==========================================
    // CREAR OBJETO
    //
    // PARA INSERTAR SE CONSERVAN TODOS LOS
    // CAMPOS QUE UTILIZAN LOS PROCEDIMIENTOS
    // DE INSERCIÓN.
    // ==========================================

    const datos = {

        // ======================================
        // EMPLEADO
        // ======================================

        NOMBREEMPLEADO:
            nombreEmpleado
                ? nombreEmpleado.value.trim()
                : '',


        DPI:
            dpi
                ? dpi.value.trim()
                : '',


        FECHANACIMIENTO:
            fechaNacimiento
                ? fechaNacimiento.value
                : null,


        EDAD:
            edadValor !== null
                ? edadValor
                : (
                    edad &&
                    edad.value
                        ? parseInt(
                            edad.value,
                            10
                        )
                        : null
                ),


        ESTADO:
            estado
                ? estado.value
                : 'A',


        FECHAREGISTROEMPLE:
            fechaRegistro
                ? fechaRegistro.value
                : null,


        DIRECCION:
            direccion
                ? direccion.value.trim()
                : '',


        // ======================================
        // TELÉFONO
        // ======================================

        TELEFONO:
            telefono
                ? telefono.value.trim()
                : '',


        ESTADOTELEFONO:
            estadoTelefono
                ? estadoTelefono.value
                : 'A',


        // ======================================
        // PUESTO
        // ======================================

        NOMBREPUESTO:
            nombrePuesto
                ? nombrePuesto.value.trim()
                : '',


        FECHAREGISTRO:
            fechaRegistroPuesto
                ? fechaRegistroPuesto.value
                : null,


        ESTADOPUESTO:
            estadoPuesto
                ? estadoPuesto.value
                : 'A',


        // ======================================
        // DEPARTAMENTO
        // ======================================

        NOMBREDEPARTAMENTO:
            nombreDepartamento
                ? nombreDepartamento.value.trim()
                : '',


        FECHAINGRESODEPART:
            fechaIngresoDepart
                ? fechaIngresoDepart.value
                : null,


        ESTADODEPARTAMENTO:
            estadoDepartamento
                ? estadoDepartamento.value
                : 'A',


        // ======================================
        // MUNICIPIO
        // ======================================

        NOMBREMUNICIPIO:
            nombreMunicipio
                ? nombreMunicipio.value.trim()
                : ''

    };


    // ==========================================
    // SI ESTÁ EDITANDO
    // ==========================================

    if (empleadoEditando) {

        datos.IDEMPLEADO =
            parseInt(
                empleadoEditando,
                10
            );

    }


    console.log(
        '================================='
    );


    console.log(
        empleadoEditando
            ? '✏️ ACTUALIZANDO EMPLEADO'
            : '➕ REGISTRANDO EMPLEADO'
    );


    console.log(
        'DATOS:',
        datos
    );


    console.log(
        '================================='
    );


    try {

        let url =
            '/empleado/insertar';


        let metodo =
            'POST';


        // ==========================================
        // ACTUALIZAR
        // ==========================================

        if (empleadoEditando) {

            url =
                '/empleado/actualizar';

            metodo =
                'PUT';

        }


        // ==========================================
        // BOTÓN
        // ==========================================

        const btnGuardar =
            document.getElementById(
                'btnGuardarEmpleado'
            );


        if (btnGuardar) {

            btnGuardar.disabled =
                true;


            btnGuardar.dataset.textoOriginal =
                btnGuardar.innerHTML;


            btnGuardar.innerHTML = `

                <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                ></span>

                Guardando...

            `;

        }


        // ==========================================
        // FETCH
        // ==========================================

        const respuesta =
            await fetch(
                url,
                {

                    method:
                        metodo,

                    headers: {

                        'Content-Type':
                            'application/json',

                        'Accept':
                            'application/json'

                    },

                    body:
                        JSON.stringify(
                            datos
                        )

                }
            );


        const texto =
            await respuesta.text();


        console.log(
            'RESPUESTA GUARDAR:',
            texto
        );


        let resultado;


        try {

            resultado =
                JSON.parse(
                    texto
                );

        } catch (error) {

            throw new Error(
                'El servidor devolvió una respuesta inválida.'
            );

        }


        if (
            !respuesta.ok ||
            resultado.success === false
        ) {

            throw new Error(
                resultado.mensaje ||
                'No se pudo guardar el empleado.'
            );

        }


        // ==========================================
        // ÉXITO
        // ==========================================

        alert(
            empleadoEditando
                ? '✅ Empleado actualizado correctamente.'
                : '✅ Empleado registrado correctamente.'
        );


        // ==========================================
        // CERRAR MODAL CORRECTO
        // ==========================================

        const idModal =
            empleadoEditando
                ? 'modalActualizar'
                : 'modalEmpleado';


        const modalElemento =
            document.getElementById(
                idModal
            );


        if (modalElemento) {

            const modal =
                bootstrap.Modal
                    .getInstance(
                        modalElemento
                    );


            if (modal) {

                modal.hide();

            }

        }


        // ==========================================
        // LIMPIAR
        // ==========================================

        if (!empleadoEditando) {

            limpiarFormulario();

        } else {

            empleadoEditando =
                null;

        }


        // ==========================================
        // RECARGAR TABLA
        // ==========================================

        await cargarEmpleados();


    } catch (error) {

        console.error(
            '❌ ERROR AL GUARDAR:',
            error
        );


        alert(
            '❌ ' +
            (
                error.message ||
                'Ocurrió un error al guardar el empleado.'
            )
        );


    } finally {

        const btnGuardar =
            document.getElementById(
                'btnGuardarEmpleado'
            );


        if (btnGuardar) {

            btnGuardar.disabled =
                false;


            if (
                btnGuardar.dataset.textoOriginal
            ) {

                btnGuardar.innerHTML =
                    btnGuardar.dataset.textoOriginal;

            }

        }

    }

}


// ==========================================
// CALCULAR EDAD
// ==========================================

function calcularEdad(
    fechaNacimiento
) {

    if (!fechaNacimiento) {

        return '';

    }


    const nacimiento =
        new Date(
            fechaNacimiento +
            'T00:00:00'
        );


    if (
        isNaN(
            nacimiento.getTime()
        )
    ) {

        return '';

    }


    const hoy =
        new Date();


    let edad =
        hoy.getFullYear() -
        nacimiento.getFullYear();


    const mes =
        hoy.getMonth() -
        nacimiento.getMonth();


    if (
        mes < 0 ||
        (
            mes === 0 &&
            hoy.getDate() <
            nacimiento.getDate()
        )
    ) {

        edad--;

    }


    return edad;

}


// ==========================================
// CONFIGURAR CÁLCULO DE EDAD
// ==========================================

function configurarCalculoEdad() {

    // ==========================================
    // NUEVO EMPLEADO
    // ==========================================

    const fechaNacimiento =
        document.getElementById(
            'fechaNacimiento'
        );


    const edad =
        document.getElementById(
            'edad'
        );


    if (
        fechaNacimiento &&
        edad
    ) {

        fechaNacimiento.addEventListener(
            'change',
            function () {

                edad.value =
                    calcularEdad(
                        this.value
                    );

            }
        );

    }


    // ==========================================
    // ACTUALIZAR EMPLEADO
    // ==========================================

    const fechaNacimientoActualizar =
        obtenerCampoModalActualizar(
            'actualizarFechaNacimiento'
        );


    const edadActualizar =
        obtenerCampoModalActualizar(
            'actualizarEdad'
        );


    if (
        fechaNacimientoActualizar &&
        edadActualizar
    ) {

        fechaNacimientoActualizar.addEventListener(
            'change',
            function () {

                edadActualizar.value =
                    calcularEdad(
                        this.value
                    );

            }
        );

    }

}


// ==========================================
// CONFIGURAR BOTÓN GUARDAR
// ==========================================

function configurarGuardarEmpleado() {

    const btnGuardar =
        document.getElementById(
            'btnGuardarEmpleado'
        );


    if (!btnGuardar) {

        console.warn(
            '⚠️ No existe #btnGuardarEmpleado'
        );

        return;

    }


    btnGuardar.addEventListener(
        'click',
        function (evento) {

            evento.preventDefault();

            guardarEmpleado();

        }
    );

}


// ==========================================
// CONFIGURAR BOTÓN NUEVO
// ==========================================

function configurarBotonNuevoEmpleado() {

    const boton =
        document.getElementById(
            'btnNuevoEmpleado'
        );


    if (!boton) {

        return;

    }


    boton.addEventListener(
        'click',
        function () {

            abrirModalNuevoEmpleado();

        }
    );

}


// ==========================================
// ACTUALIZAR EMPLEADO
// ==========================================

function configurarActualizacionEmpleado() {

    const btnActualizarEmpleado =
        document.getElementById(
            'btnActualizarEmpleado'
        );


    if (!btnActualizarEmpleado) {

        console.warn(
            '⚠️ No existe #btnActualizarEmpleado'
        );

        return;

    }


    btnActualizarEmpleado.addEventListener(
        'click',
        async function (evento) {

            evento.preventDefault();


            // ==========================================
            // CAMPOS
            // ==========================================

            const campoId =
                obtenerCampoModalActualizar(
                    'actualizarIdEmpleado'
                );


            const campoNombre =
                obtenerCampoModalActualizar(
                    'actualizarNombreEmpleado'
                );


            const campoDpi =
                obtenerCampoModalActualizar(
                    'actualizarDpi'
                );


            const campoFechaNacimiento =
                obtenerCampoModalActualizar(
                    'actualizarFechaNacimiento'
                );


            const campoEdad =
                obtenerCampoModalActualizar(
                    'actualizarEdad'
                );


            const campoEstado =
                obtenerCampoModalActualizar(
                    'actualizarEstado'
                );


            const campoFechaRegistro =
                obtenerCampoModalActualizar(
                    'actualizarFechaRegistro'
                );


            const campoDireccion =
                obtenerCampoModalActualizar(
                    'actualizarDireccion'
                );


            const campoTelefono =
                obtenerCampoModalActualizar(
                    'actualizarTelefono'
                );


            const campoNombrePuesto =
                obtenerCampoModalActualizar(
                    'actualizarNombrePuesto'
                );


            const campoDepartamento =
                obtenerCampoModalActualizar(
                    'actualizarNombreDepartamento'
                );


            const campoEstadoDepartamento =
                obtenerCampoModalActualizar(
                    'actualizarEstadoDepartamento'
                );


            const campoMunicipio =
                obtenerCampoModalActualizar(
                    'actualizarNombreMunicipio'
                );


            // ==========================================
            // CAMPOS VISUALES
            //
            // PUEDEN EXISTIR EN EL MODAL.
            //
            // NO SE UTILIZAN PARA SP_EMPLEADO_U.
            // ==========================================

            const campoEstadoTelefono =
                obtenerCampoModalActualizar(
                    'actualizarEstadoTelefono'
                );


            const campoFechaRegistroPuesto =
                obtenerCampoModalActualizar(
                    'actualizarFechaRegistroPuesto'
                );


            const campoEstadoPuesto =
                obtenerCampoModalActualizar(
                    'actualizarEstadoPuesto'
                );


            const campoFechaIngresoDepart =
                obtenerCampoModalActualizar(
                    'actualizarFechaIngresoDepart'
                );


            // ==========================================
            // VALIDAR CAMPOS NECESARIOS
            //
            // ESTOS SON LOS QUE CORRESPONDEN
            // AL SP_EMPLEADO_U
            // ==========================================

            if (
                !campoId ||
                !campoNombre ||
                !campoDpi ||
                !campoFechaNacimiento ||
                !campoEdad ||
                !campoEstado ||
                !campoFechaRegistro ||
                !campoDireccion ||
                !campoTelefono ||
                !campoNombrePuesto ||
                !campoDepartamento ||
                !campoEstadoDepartamento ||
                !campoMunicipio
            ) {

                alert(
                    '❌ No se encontraron todos los campos necesarios del modal de actualización.'
                );

                return;

            }


            // ==========================================
            // ASEGURAR INPUTS DATE
            // ==========================================

            campoFechaNacimiento.type =
                'date';


            campoFechaRegistro.type =
                'date';


            // ==========================================
            // VALORES
            // ==========================================

            const id =
                parseInt(
                    campoId.value,
                    10
                );


            const nombre =
                campoNombre.value.trim();


            const dpi =
                campoDpi.value.trim();


            const fechaNacimiento =
                campoFechaNacimiento.value;


            const edad =
                parseInt(
                    campoEdad.value,
                    10
                );


            const estado =
                campoEstado.value ||
                'A';


            const fechaRegistro =
                campoFechaRegistro.value;


            const direccion =
                campoDireccion.value.trim();


            const telefono =
                campoTelefono.value.trim();


            const nombrePuesto =
                campoNombrePuesto.value.trim();


            const departamento =
                campoDepartamento.value.trim();


            const estadoDepartamento =
                campoEstadoDepartamento.value ||
                'A';


            const municipio =
                campoMunicipio.value.trim();


            // ==========================================
            // VALIDAR ID
            // ==========================================

            if (
                isNaN(id) ||
                id <= 0
            ) {

                alert(
                    '❌ El ID del empleado no es válido.'
                );

                return;

            }


            // ==========================================
            // VALIDAR NOMBRE
            // ==========================================

            if (!nombre) {

                alert(
                    '❌ El nombre del empleado es obligatorio.'
                );

                campoNombre.focus();

                return;

            }


            // ==========================================
            // VALIDAR DPI
            // ==========================================

            if (!dpi) {

                alert(
                    '❌ El DPI es obligatorio.'
                );

                campoDpi.focus();

                return;

            }


            // ==========================================
            // VALIDAR FECHA NACIMIENTO
            // ==========================================

            if (!fechaNacimiento) {

                alert(
                    '❌ La fecha de nacimiento es obligatoria.'
                );

                campoFechaNacimiento.focus();

                return;

            }


            // ==========================================
            // VALIDAR EDAD
            // ==========================================

            if (
                isNaN(edad) ||
                edad < 0
            ) {

                alert(
                    '❌ La edad no es válida.'
                );

                campoEdad.focus();

                return;

            }


            // ==========================================
            // VALIDAR FECHA REGISTRO
            // ==========================================

            if (!fechaRegistro) {

                alert(
                    '❌ La fecha de registro del empleado es obligatoria.'
                );

                campoFechaRegistro.focus();

                return;

            }


            // ==========================================
            // VALIDAR DIRECCIÓN
            // ==========================================

            if (!direccion) {

                alert(
                    '❌ La dirección es obligatoria.'
                );

                campoDireccion.focus();

                return;

            }


            // ==========================================
            // VALIDAR TELÉFONO
            // ==========================================

            if (
                !/^[0-9]{8}$/.test(
                    telefono
                )
            ) {

                alert(
                    '❌ El teléfono debe contener exactamente 8 dígitos.'
                );

                campoTelefono.focus();

                return;

            }


            // ==========================================
            // VALIDAR PUESTO
            // ==========================================

            if (!nombrePuesto) {

                alert(
                    '❌ El nombre del puesto es obligatorio.'
                );

                campoNombrePuesto.focus();

                return;

            }


            // ==========================================
            // VALIDAR DEPARTAMENTO
            // ==========================================

            if (!departamento) {

                alert(
                    '❌ El departamento es obligatorio.'
                );

                campoDepartamento.focus();

                return;

            }


            // ==========================================
            // VALIDAR MUNICIPIO
            // ==========================================

            if (!municipio) {

                alert(
                    '❌ El municipio es obligatorio.'
                );

                campoMunicipio.focus();

                return;

            }


            // ==========================================
            // CREAR DATOS
            //
            // MUY IMPORTANTE:
            //
            // NO SE ENVÍAN:
            //
            // FECHAINGRESODEPART
            // ESTADOTELEFONO
            // FECHAREGISTRO
            // ESTADOPUESTO
            //
            // EXCEPTO FECHAREGISTROEMPLE,
            // QUE SÍ EXISTE EN SP_EMPLEADO_U.
            // ==========================================

            const datos = {

                IDEMPLEADO:
                    id,

                NOMBREEMPLEADO:
                    nombre,

                DPI:
                    dpi,

                EDAD:
                    edad,

                FECHANACIMIENTO:
                    fechaNacimiento,

                FECHAREGISTROEMPLE:
                    fechaRegistro,

                DIRECCION:
                    direccion,

                TELEFONO:
                    telefono,

                NOMBREDEPARTAMENTO:
                    departamento,

                ESTADODEPARTAMENTO:
                    estadoDepartamento,

                NOMBREMUNICIPIO:
                    municipio,

                ESTADO:
                    estado,

                NOMBREPUESTO:
                    nombrePuesto

            };


            // ==========================================
            // MOSTRAR DATOS
            // ==========================================

            console.log(
                '================================='
            );

            console.log(
                '✏️ DATOS PARA ACTUALIZAR'
            );

            console.log(
                datos
            );

            console.log(
                '================================='
            );


            // ==========================================
            // DESHABILITAR BOTÓN
            // ==========================================

            btnActualizarEmpleado.disabled =
                true;


            const textoOriginal =
                btnActualizarEmpleado.innerHTML;


            btnActualizarEmpleado.innerHTML = `

                <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                ></span>

                Actualizando...

            `;


            try {

                // ==========================================
                // PETICIÓN
                // ==========================================

                const respuesta =
                    await fetch(
                        '/empleado/actualizar',
                        {

                            method:
                                'PUT',

                            headers: {

                                'Content-Type':
                                    'application/json',

                                'Accept':
                                    'application/json'

                            },

                            body:
                                JSON.stringify(
                                    datos
                                )

                        }
                    );


                // ==========================================
                // RESPUESTA
                // ==========================================

                const texto =
                    await respuesta.text();


                console.log(
                    'RESPUESTA ACTUALIZAR:',
                    texto
                );


                let resultado;


                try {

                    resultado =
                        JSON.parse(
                            texto
                        );

                } catch (error) {

                    console.error(
                        '❌ Respuesta no válida:',
                        texto
                    );

                    throw new Error(
                        'El servidor devolvió una respuesta inválida.'
                    );

                }


                // ==========================================
                // VALIDAR RESPUESTA
                // ==========================================

                if (
                    !respuesta.ok ||
                    resultado.success === false
                ) {

                    throw new Error(
                        resultado.mensaje ||
                        'No se pudo actualizar el empleado.'
                    );

                }


                // ==========================================
                // ÉXITO
                // ==========================================

                alert(
                    resultado.mensaje ||
                    '✅ Empleado actualizado correctamente.'
                );


                // ==========================================
                // CERRAR MODAL
                // ==========================================

                const modalElemento =
                    document.getElementById(
                        'modalActualizar'
                    );


                if (modalElemento) {

                    const modal =
                        bootstrap.Modal
                            .getInstance(
                                modalElemento
                            );


                    if (modal) {

                        modal.hide();

                    }

                }


                // ==========================================
                // REINICIAR VARIABLE
                // ==========================================

                empleadoEditando =
                    null;


                // ==========================================
                // RECARGAR TABLA
                // ==========================================

                await cargarEmpleados();


            } catch (error) {

                console.error(
                    '❌ ERROR AL ACTUALIZAR:',
                    error
                );


                alert(
                    '❌ ' +
                    (
                        error.message ||
                        'Ocurrió un error al actualizar el empleado.'
                    )
                );


            } finally {

                btnActualizarEmpleado.disabled =
                    false;


                btnActualizarEmpleado.innerHTML =
                    textoOriginal;

            }

        }
    );

}


// ==========================================
// ABRIR MODAL ELIMINAR
// ==========================================

function abrirModalEliminar(idEmpleado) {

    const empleado =
        empleadosGlobales.find(
            item =>
                Number(
                    item.IDEMPLEADO
                ) ===
                Number(
                    idEmpleado
                )
        );


    if (!empleado) {

        alert(
            '❌ No se encontró el empleado.'
        );

        return;

    }


    const campoId =
        document.getElementById(
            'eliminarIdEmpleado'
        );


    const campoNombre =
        document.getElementById(
            'eliminarNombreEmpleado'
        );


    if (!campoId) {

        console.error(
            '❌ No existe #eliminarIdEmpleado'
        );

        return;

    }


    if (!campoNombre) {

        console.error(
            '❌ No existe #eliminarNombreEmpleado'
        );

        return;

    }


    campoId.value =
        empleado.IDEMPLEADO;


    campoNombre.textContent =
        empleado.NOMBREEMPLEADO || '';


    const modalElemento =
        document.getElementById(
            'modalEliminar'
        );


    if (!modalElemento) {

        console.error(
            '❌ No existe #modalEliminar'
        );

        return;

    }


    if (
        typeof bootstrap ===
        'undefined'
    ) {

        console.error(
            '❌ Bootstrap no está disponible'
        );

        return;

    }


    const modal =
        bootstrap.Modal
            .getOrCreateInstance(
                modalElemento
            );


    modal.show();

}


// ==========================================
// CONFIGURAR ELIMINACIÓN
// ==========================================

function configurarEliminacionEmpleado() {

    const btnConfirmarEliminar =
        document.getElementById(
            'btnConfirmarEliminar'
        );


    if (!btnConfirmarEliminar) {

        console.warn(
            '⚠️ No existe #btnConfirmarEliminar'
        );

        return;

    }


    btnConfirmarEliminar.addEventListener(
        'click',
        async function () {

            const campoId =
                document.getElementById(
                    'eliminarIdEmpleado'
                );


            if (!campoId) {

                alert(
                    '❌ No existe el campo del ID.'
                );

                return;

            }


            const id =
                parseInt(
                    campoId.value,
                    10
                );


            if (
                isNaN(id) ||
                id <= 0
            ) {

                alert(
                    '❌ El ID del empleado no es válido.'
                );

                return;

            }


            const confirmar =
                confirm(
                    '¿Está seguro de desactivar este empleado?'
                );


            if (!confirmar) {

                return;

            }


            btnConfirmarEliminar.disabled =
                true;


            const textoOriginal =
                btnConfirmarEliminar.innerHTML;


            btnConfirmarEliminar.innerHTML = `

                <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                ></span>

                Desactivando...

            `;


            try {

                const respuesta =
                    await fetch(
                        '/empleado/eliminar',
                        {

                            method:
                                'PUT',

                            headers: {

                                'Content-Type':
                                    'application/json',

                                'Accept':
                                    'application/json'

                            },

                            body:
                                JSON.stringify({

                                    IDEMPLEADO:
                                        id

                                })

                        }
                    );


                const texto =
                    await respuesta.text();


                console.log(
                    'RESPUESTA ELIMINAR:',
                    texto
                );


                let resultado;


                try {

                    resultado =
                        JSON.parse(
                            texto
                        );

                } catch (error) {

                    throw new Error(
                        'El servidor devolvió una respuesta inválida.'
                    );

                }


                if (
                    !respuesta.ok ||
                    resultado.success === false
                ) {

                    throw new Error(
                        resultado.mensaje ||
                        'No se pudo desactivar el empleado.'
                    );

                }


                alert(
                    resultado.mensaje ||
                    '✅ Empleado desactivado correctamente.'
                );


                // ==========================================
                // CERRAR MODAL
                // ==========================================

                const modalElemento =
                    document.getElementById(
                        'modalEliminar'
                    );


                if (modalElemento) {

                    const modal =
                        bootstrap.Modal
                            .getInstance(
                                modalElemento
                            );


                    if (modal) {

                        modal.hide();

                    }

                }


                campoId.value =
                    '';


                // ==========================================
                // RECARGAR
                // ==========================================

                await cargarEmpleados();


            } catch (error) {

                console.error(
                    '❌ ERROR AL DESACTIVAR:',
                    error
                );


                alert(
                    '❌ ' +
                    error.message
                );


            } finally {

                btnConfirmarEliminar.disabled =
                    false;


                btnConfirmarEliminar.innerHTML =
                    textoOriginal;

            }

        }
    );

}


// ==========================================
// CONFIGURAR BOTONES DE TABLA
// ==========================================

function configurarBotonesTabla() {

    const tbody =
        document.getElementById(
            'tbodyEmpleados'
        );


    if (!tbody) {

        return;

    }


    tbody.addEventListener(
        'click',
        function (evento) {

            // ==========================================
            // EDITAR
            // ==========================================

            const botonEditar =
                evento.target.closest(
                    '.btnEditarEmpleado'
                );


            if (botonEditar) {

                const id =
                    botonEditar.getAttribute(
                        'data-id'
                    );


                if (id) {

                    abrirModalActualizar(
                        id
                    );

                }


                return;

            }


            // ==========================================
            // ELIMINAR
            // ==========================================

            const botonEliminar =
                evento.target.closest(
                    '.btnEliminarEmpleado'
                );


            if (botonEliminar) {

                const id =
                    botonEliminar.getAttribute(
                        'data-id'
                    );


                if (id) {

                    abrirModalEliminar(
                        id
                    );

                }

            }

        }
    );

}


// ==========================================
// CONFIGURAR EVENTOS
// ==========================================

function configurarEventosEmpleado() {

    configurarCalculoEdad();

    configurarGuardarEmpleado();

    configurarActualizacionEmpleado();

    configurarEliminacionEmpleado();

    configurarBotonNuevoEmpleado();

    configurarBotonesTabla();

    buscarEmpleados();

    colocarFechas();

}


// ==========================================
// INICIALIZAR EMPLEADO
// ==========================================

function inicializarEmpleado() {

    console.log(
        '👤 Módulo empleado inicializado'
    );


    configurarEventosEmpleado();

    cargarEmpleados();

}


// ==========================================
// EXPORTACIONES
// ==========================================

export {

    cargarEmpleados,

    inicializarEmpleado,

    abrirModalActualizar,

    abrirModalNuevoEmpleado,

    abrirModalEliminar,

    guardarEmpleado

};